import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetGetYourGuideTours'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetGetYourGuideToursStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetGetYourGuideToursStore",
			variables: true,
		})
	}
}

export async function load_GetGetYourGuideTours(params) {
  await initClient()

	const store = new GetGetYourGuideToursStore()

	await store.fetch(params)

	return {
		GetGetYourGuideTours: store,
	}
}
